
window.slate = window.slate || {}
window.theme = window.theme || {}

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  },
  gwpSettings: function() {
    const gwp = document.querySelector('#gwp-settings');
    return {
      gwp,
      gwpThreshold: gwp ? parseInt(gwp.dataset.gwpThreshold) : null,
      gwpEnabled: gwp ? gwp.dataset.gwpEnabled === 'true' : false,
      gwpProductId: gwp ? parseInt(gwp.dataset.gwpProductId) : null,
      gwpProductPrice: gwp ? parseInt(gwp.dataset.gwpProductPrice) : null
    }
  },
  addGiftToCart: function () {
    const {gwpThreshold, gwpEnabled, gwpProductId, gwpProductPrice} = this.gwpSettings();
    if (gwpEnabled) {
      $(document).on('cart.requestComplete', (event, cart) => {
        const isFreeProductInCart = cart.items.some(item => item.id === gwpProductId && item.discounted_price === 0);
        const isPaidFreeProductInCart = cart.items.some(item => item.id === gwpProductId && item.discounted_price !== 0);
        const isEveryItemFreeProduct = cart.items.every(item => item.id === gwpProductId);
        const freePaidProduct = cart.items.filter(item => item.id === gwpProductId && item.discounted_price !== 0);
        const freeProduct = cart.items.filter(item => item.id === gwpProductId && item.discounts.length)[0];
        isFreeProductInCart ? freeProduct.is_free = true : null;
        isFreeProductInCart ? freeProduct.message = freeProduct.discounts.find(discount => discount.title.includes('Free')).title : null;

        if (!this.isFreeProductInCart(cart.items, gwpProductId) && parseInt(cart.total_price) > gwpThreshold) {
          CartJS.addItem(gwpProductId, 1);
        }
      })
    }
  },
  updateGiftInCart: function (cartTotal, cartItems, updateQty) {
    const {gwpThreshold, gwpEnabled, gwpProductId, gwpProductPrice} = this.gwpSettings();
    if (gwpEnabled) {
      if (!this.isFreeProductInCart(cartItems, gwpProductId) && cartTotal > gwpThreshold) {
        this.addFreeProductToCart(gwpProductId)
      } else if (cartTotal < gwpThreshold) {
        this.removeFreeProductFromCart(gwpProductId)
      } else if (this.isPaidFreeProductInCart(cartItems, gwpProductId) && (cartTotal - gwpProductPrice) < gwpThreshold) {
        this.removeFreeProductFromCart(gwpProductId)
      }
    }
  },
  addFreeProductToCart: function (gwpProductId) {
    const itemToAdd = {
      items: [{
        id: gwpProductId,
        quantity: 1
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(itemToAdd)
    }).then(response => {
      if (response.status === 200) {
        window.location.reload();
      }
      response.json().then(data => {
        console.log(data);
      })
    }).catch(err => console.error('Error!', err.message))
  },
  removeFreeProductFromCart: function (gwpProductId, quantity = 0) {
    const itemToUpdate = JSON.stringify({quantity: quantity, id: gwpProductId.toString()})
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: itemToUpdate
    }).then().then(response => {
      response.json()
      if (response.status === 200) {
        window.location.reload();
      }
    }).catch(err => console.error('Error!', err.message))
  },
  updateFreePaidProductQuantity: function (gwpProductId, updateQty, cartItems) {
    const lineItemToUpdate = cartItems.findIndex(item => item.id === gwpProductId)+1;
    const itemToUpdate = JSON.stringify({quantity: updateQty, line: lineItemToUpdate})
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: itemToUpdate
    }).then(response => {
      if (response.status === 200) {
        window.location.reload();
      } else {
        console.error(response);
      }
    }).catch(err => console.error(err.message))
  },
  updateFreeGiftOnPageLoad: function (cartItems, cartTotal) {
    const isCartPage = document.querySelector('.template-cart');
    const {gwpThreshold, gwpEnabled, gwpProductId, gwpProductPrice} = this.gwpSettings();
    const isFreeProductInCart = this.isFreeProductInCart(cartItems, gwpProductId);
    const isPaidFreeProductInCart =this.isPaidFreeProductInCart(cartItems, gwpProductId);
    const isEveryItemGiftProduct = this.isEveryItemGiftProduct(cartItems, gwpProductId);
    const productLineItem = document.querySelector('#cart-form tbody');
    if (isCartPage && gwpEnabled) {
      if (!isFreeProductInCart && cartTotal > gwpThreshold) {
        this.addFreeProductToCart(gwpProductId);
      } else if (isFreeProductInCart && cartTotal < gwpThreshold) {
        this.removeFreeProductFromCart(gwpProductId)
      } else if (isPaidFreeProductInCart && (cartTotal - gwpProductPrice) < gwpThreshold) {
        this.removeFreeProductFromCart(gwpProductId)
      }
    }
  },
  findFreeGiftLineItem: function (lineItems, gwpProductId) {
    const lineItemsArray = Array.from(lineItems);
    return lineItemsArray
      .find(lineItem => {
        return lineItem.dataset.productId === gwpProductId.toString()
      });
  },
  countFreeAndPaidProducts: function (cartItems, gwpProductId) {
    return cartItems.filter(item => item.id === gwpProductId)[0].quantity
  },
  onDecreaseClick: function (cart) {
    const cartDraw = document.querySelector('.cart-draw');
    const {gwpThreshold, gwpEnabled, gwpProductId, gwpProductPrice} = this.gwpSettings();
    const cartItems = cart.items;
    const isPaidFreeProduct = this.isPaidFreeProductInCart(cartItems, gwpProductId);
    const isFreeProduct = this.isFreeProductInCart(cartItems, gwpProductId);
    const paidFreeProductQty = isPaidFreeProduct ? this.paidFreeProduct(cartItems, gwpProductId).quantity : 0;
    const isEveryProductGift = this.isEveryItemGiftProduct(cartItems, gwpProductId);

    cartDraw.addEventListener('click', (event) => {
      const isDecreaseButton = event.target.parentNode.classList.contains('decrease-qty');
      const isLineItemFreeProduct = event.target.parentNode.dataset.productId === gwpProductId.toString();
      const lineItemProductPrice = parseInt(event.target.parentNode.dataset.productPrice);
      if (isDecreaseButton) {
        if (isEveryProductGift && isPaidFreeProduct && isFreeProduct && paidFreeProductQty === 2
            && isLineItemFreeProduct && (cart.total_price - gwpProductPrice) < gwpThreshold) {
            this.updateFreeProduct(cartItems, gwpProductId);
          } else if (isPaidFreeProduct && paidFreeProductQty === 1 && isLineItemFreeProduct
            && (cart.total_price - gwpProductPrice) < gwpThreshold) {
            this.updateFreeProduct(cartItems, gwpProductId, 0);
          } else if (isFreeProduct && isPaidFreeProduct && (cart.total_price - lineItemProductPrice) < gwpThreshold) {
            CartJS.removeItemById(gwpProductId);
          }
        }
    })
  },
  isEveryItemGiftProduct: function (cartItems, gwpProductId) {
    return cartItems.every(item => item.id === gwpProductId);
  },
  isPaidFreeProductInCart: function (cartItems, gwpProductId) {
    return cartItems.some(item => item.id === gwpProductId && item.discounted_price !== 0);
  },
  isFreeProductInCart: function (cartItems, gwpProductId) {
    return cartItems.some(item => item.id === gwpProductId);
  },
  paidFreeProduct: function (cartItems, gwpProductId) {
    return cartItems.filter(item => item.id === gwpProductId && item.discounted_price !== 0)[0];
  },
  freeProduct: function (cartItems, gwpProductId) {
    return cartItems.filter(item => item.id === gwpProductId && item.discounted_price === 0)[0];
  },
  updateFreeProduct: function (cartItems, gwpProductId, paidProduct = 1) {
    const lineItemPaid = cartItems.findIndex(item => item.id === gwpProductId && item.discounted_price !== 0) + 1;
    const lineItemFree = cartItems.findIndex(item => item.id === gwpProductId && item.discounted_price === 0) + 1;
    if (lineItemFree > 0 && lineItemPaid > 0) {
      CartJS.updateItem(lineItemPaid, paidProduct);
      CartJS.removeItem(lineItemFree);
    }
  },
  updateFreeProductInCartDraw: function () {
    $(document).on('cart.requestComplete', (event, cart) => {
      const cartItems = cart.items;
      const {gwpProductId} = this.gwpSettings();
      const isFreeProductInCart = this.isFreeProductInCart(cartItems, gwpProductId);
      const freeProduct = this.freeProduct(cartItems, gwpProductId);
      if (isFreeProductInCart) {
        freeProduct.is_free = true;
        freeProduct.message = freeProduct.discounts.find(discount => discount.title.includes('Free')).title;
      }
    })
  },
  removeGwpProductFromCart: function (event, gwpProductId, cartTotal, gwpThreshold) {
    if (event.target.classList.contains('remove')) {
        const productId = parseInt(event.target.dataset.productId);
        if (cartTotal < gwpThreshold) {
          this.removeFreeProductFromCart(gwpProductId);
        }
        if (productId === gwpProductId) {
          this.removeFreeProductFromCart(gwpProductId);
        }
    }
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    imageWrapper: '[data-image-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    numInputs: 'input[type="number"]',
    productCard: '.product-card',
    relatedProducts: '.related-products'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');

    this.settings = {};
    this.namespace = '.product';

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    this.settings.imageSize = slate.Image.imageSize($(selectors.productFeaturedImage, this.$container).attr('src'));

    slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    this.initVariants();
    this.initImagesSwitch();
    this.productImageZoom();
    this.initQtySelector();
    this.initRelatedProducts();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Handles change events from the variant inputs
     */
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    },

    initImagesSwitch: function() {
      if (!$(selectors.productThumbs, this.$container).length) {
        return;
      }

      var self = this;

      $(selectors.productThumbs, this.$container).on('click', function(evt) {
        evt.preventDefault();

        var $el = $(this);
        var imageSrc = $el.attr('href');

        self.switchImage(imageSrc);
      });
    },

    productImageZoom: function() {
      if (!$(selectors.imageWrapper, this.$container).length) {
        return;
      }

      // Destroy zoom (in case it was already set), then set it up again
      $(selectors.imageWrapper, this.$container).trigger('zoom.destroy');

      $(selectors.imageWrapper, this.$container).zoom({
        url: $(selectors.productFeaturedImage, this.$container).data('zoom')
      });
    },

    switchImage: function(imageSrc) {
      $(selectors.productFeaturedImage, this.$container)
        .attr('src', imageSrc)
        .data('zoom', imageSrc);

      this.productImageZoom();
    },

    initQtySelector: function() {
      this.$container.find(selectors.numInputs).each(function(i, el) {
        new QtySelector($(el));
      });
    },

    initRelatedProducts: function() {
      var $relatedProducts = this.$container.siblings(selectors.relatedProducts);

      if (!$relatedProducts.length) {
        return;
      }

      $relatedProducts.on('click.productCard', selectors.productCard, theme.ProductCard.onClick);
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      $(selectors.productFeaturedImage, this.$container).attr('src', sizedImgUrl);

      this.switchImage(sizedImgUrl);
      this.productImageZoom();
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
      $(selectors.productFeaturedImage).off('.productCard');
    }
  });

  return Product;
})();

// const cookiesMessage = document?.querySelector('.cookies-popup')
// const closeCookieMessage = document?.querySelector('.close-cookie-message')
// const cookieAccepted = Cookies.get('cookies_accepted')

// if (cookieAccepted !== 'true') {
//   cookiesMessage.classList.remove('d-none')
// }

// if (closeCookieMessage) {
//   closeCookieMessage.addEventListener('click', () => {
//     cookiesMessage.classList.add('d-none')
//     Cookies.set('cookies_accepted', 'true', {expires: 365})
//   })
// }



/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
    if(!$newAddressForm.hasClass('hide')){
      $(this).html('cancel');
    } else {
      $(this).html('add a new address');
    }
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
    if (!$('#EditAddress_' + formId).hasClass('hide')) {
      $(this).html('cancel');
    } else {
      $(this).html('edit');
    }

  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/*
storeLocator({
    container: 'my-store-locator',
    apiKey: 'AIzaSyCO9TfbbV0j_iRdsi2b2rZx26jEVd-5XI0',
    center: {lat: -28.145684, lng: 153.472315},
    searchHint: "",
    zoom: 8,
    styles: [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5f7fa"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "color": "#45c7e7"
      },
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#08a8c5"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#effaff"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#45c7e7"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#d9f3f8"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#1698b8"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dff5f9"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#1698b8"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#1698b8"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#5ac6e5"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#1698b8"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#19b0d6"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#8de1f3"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dff5f9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#8bd6ec"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#45c7e7"
      }
    ]
  }
],
    stores: [
      {
        name: 'The Wholefood Pantry Store',
        address: '6 Leonard Parade, Currumbin Qld 4223',
        location: {lat: -28.145684, lng: 153.472315},
        website: 'http://nutraorganics.com.au'
      },
      {
        name: 'Caloundra Health Food Centre',
        address: "29 Bulcock St, Caloundra QLD 4551, Australia",
        location: {lat: -26.804688, lng: 153.1331955}
      },
      {
        name: 'ABC Vitamins - CARINGBAH',
        address: "Shop 11 Caringbah Shopping Village Caringbah NSW 2229",
        phone: '02 9524 0608',
        location: {lat: -34.0435394, lng: 151.1162301}
      },
      {
        name: 'GO VITA - ROBINA',
        address: "19 Robina Town Centre Dr, Robina QLD 4226",
        phone: '(07) 5562 2533',
        location: {lat: -28.0759892, lng: 153.3843265}
      }
    ]
  });
*/

theme.productCollectionsCard = {
  productCard: function () {
    const collection = $('#product');
    const isProductCollection = collection.context.URL.includes('collections');
    if (isProductCollection) {
      console.log('product collection page');
      const variantSelect = $('.variant-select');
      const quantity = $('.variant-quantity');
      const button = $('.add-to-cart');
      variantSelect.on('change', function (e) {
        const variantId = $(this).val();
        const variantQty = $(e.target).closest('.product-details').find('.variant-quantity');
        variantQty.val(1);
        $(this).closest('.product-details')
          .find('.add-to-cart').attr('data-cart-add', variantId);
      });

      quantity.on('change', function () {
        const qty = $(this).val();
        $(this).closest('.product-details')
          .find('.add-to-cart').attr('data-cart-quantity', qty);
      })

      $(document).on('click', function (event) {
        const target = $(event.target);
        const increment = event.shiftKey ? 10 : 1;
        if (target.hasClass('inc')) {
          let qty = target.closest('.product-details').find('.variant-quantity');
          qty.val(parseInt(qty.val())+increment)
          quantity.trigger('change');
        }
        if (target.hasClass('dec')) {
          let qty = target.closest('.product-details').find('.variant-quantity');
          if (qty.val() > increment) {
            qty.val(parseInt(qty.val())-increment)
          }
          quantity.trigger('change');
        }
      })

      button.on('click', function (event) {
        const target = $(event.target);
        target.closest('.product-details').find('.variant-quantity').val(1);
      })
    }
  }
}


/*=============== Features ===================*/

// const countdownElement = $('.countdown');
// // const endDate = countdownElement[0].dataset.endDate;
// const endDate = moment(countdownElement[0].dataset.endDate, 'DD/MM/YYYY HH:mm:ss').tz('Australia/Sydney').format();
// console.log('endDataFormatted', endDate);
// const countdownToTime = new Date(endDate).getTime();
// const countdownEnabled = endDate ? true : false;
// const prefixText = countdownElement[0].dataset.prefixText;
// const endMessage = countdownElement[0].dataset.endMessage;

// if (countdownEnabled) {
//   const countdown = setInterval(function () {
//     const current = new Date().getTime();
//     const timeToEnd = countdownToTime - current;
//     const days = addProceedingZero(Math.floor(timeToEnd / (1000 * 60 * 60 * 24)));
//     const hours = addProceedingZero(Math.floor((timeToEnd % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
//     const minutes = addProceedingZero(Math.floor((timeToEnd % (1000 * 60 * 60)) / (1000 * 60)));
//     const seconds = addProceedingZero(Math.floor((timeToEnd % (1000 * 60)) / 1000));


//     countdownElement.html(`${prefixText} ${parseInt(days)}<span class="label">days</span> ${parseInt(hours)}<span class="label">hrs</span> ${parseInt(minutes)}<span class="label">min</span> ${parseInt(seconds)}<span class="label">sec</span>`);

//     if (timeToEnd < 0) {
//       clearInterval(countdown);
//       countdownElement.html(`${endMessage}`);
//     }

//   }, 1000)
// }

// function addProceedingZero (num) {
//   return num < 10 ? '0' + num : num
// }



$(document).ready(function () {

  const fullDescription = $('.full-description');
  const readMoreLink = $('.read-more-link');

  fullDescription.css({display: 'none'});
  var hideFullDescription = true;
  readMoreLink.html('Read more');

  readMoreLink.on('click', (e) => {
    e.preventDefault();
    if (hideFullDescription) {
      hideFullDescription = false;
      readMoreLink.html('Read less');
      fullDescription.css({display: 'block'});
    } else {
      hideFullDescription = true;
      readMoreLink.html('Read more');
      fullDescription.css({display: 'none'});
    }
  });


  var sections = new slate.Sections()
  sections.register('product', theme.Product)

  $('#country-popup').on('hidden.bs.modal', function () {
    Cookies.set('nutraNZPopupClosed', 'true', {expires: 1})
  })

  $('#usa-popup').on('hidden.bs.modal', function () {
    Cookies.set('nutraUSAPopupClosed', 'true', {expires: 1})
  })

  $('.switch-image-thumb a, .product-thumb a').on('click', function (e) {
    e.preventDefault()
    let $el = $(this)
    let imageSrc = $el.attr('href')
    let ext = imageSrc.split('.')
    ext = ext[ext.length - 1]

    if (ext === 'mp4') {
      $('.switch-image').css({display: 'none'})
      $('.video-container').append(`
        <div class="embed-responsive embed-responsive-4by5">
          <video class=".embed-responsive-item" controls autoplay>
              <source src="${imageSrc}" type="video/mp4">
          </video>
        </div>
        `)
    } else {
      $('.switch-image').css({display: 'block'})
      $('.embed-responsive').remove()
      $('.switch-image').attr('src', imageSrc)
    }
  })

  $('#collections-container').searchable({
    selector: '.collection-product',
    childSelector: '.product-info',
    searchField: '#product-filter',
    striped: false,
    searchType: 'default',
    hide: function (elem) {
      elem.fadeOut(200)
    },
    show: function (elem) {
      elem.fadeIn(200)
    }
  })

  // Dropdown

  $('.more-toggle').on('click', function (e) {
    e.preventDefault()
    $('.second-menu').toggleClass('open').parent().toggleClass('open').parent().toggleClass('open')
    $('.more-toggle').toggleClass('open')
  })

  //Product nav

  $('.js-open-product-nav').on('click', function (e) {
    $('.product-nav').toggleClass('open-nav')
    $('.expand-header').toggleClass('collapsed')
  })

  // Account dropdown

  let accountToggle = $('.acc-dropdown');

  accountToggle.on('click', function (e) {
    e.stopPropagation();
    $(this).toggleClass('active');

  })

  $(document).on('click', function (e) {
    if ($(e.target).is(accountToggle) === false) {
      accountToggle.removeClass('active');
    }
  })

  // Main menu behaviour

  var mainNavItem = $('.main-menu > .drop-down > a')

  mainNavItem.on('click', function (e) {
    e.preventDefault()
    e.stopPropagation()
    $(this).parent('.parent-items')
      .toggleClass('active')
      .siblings()
      .removeClass('active')

    $('.js-open-mega').removeClass('active')
    $('.mega-menu').removeClass('active')
    $('.acc-dropdown-menu').removeClass('active')
  })

  // Mega menu behaviour

  var menuItem = $('.mega-parent > .js-open-mega > a')

  menuItem.on('click', function (e) {
    e.preventDefault()
    e.stopPropagation()
    $(this).parent().toggleClass('active')
      .parent()
      .siblings()
      .children()
      .removeClass('active')

    $('.drop-down').removeClass('active')
    $('.acc-dropdown-menu').removeClass('active')
  })

  var menuButton = $('.js-open-mega'),
    mainNav = $('.mega-menu')

  // close any open menus when page loads
  $(document).ready(function () {
    $('.js-open-mega.active').removeClass('active')
  })

  // close open menus when clicking outside the menu

  $('#shopify-section-header').on('click', function (e) {
    $('.mega-menu').removeClass('active')
  })

  $('.nav-burger').on('click', function (e) {
    $('body').toggleClass('menu-active')
    $(window).on('scroll', function () {
      $('body').removeClass('menu-active')
    })
  })

  $('.child-item').on('click', function () {
    $(this).toggleClass('active').siblings().removeClass('active')
  })

  //Show search field

  $('.js-show-search').on('click', function (e) {
    e.stopPropagation()
    e.preventDefault()
    $('#search').focus()
    $('.acc-dropdown-menu').removeClass('active')
    if ($('#search:focus')) {
      $('.js-show-search').addClass('search-active')
    }
    $('#search').on('blur', function () {
      $('.js-show-search').removeClass('search-active')
    })
  })

  $('#MainContent').on('click', function (e) {
    $('.acc-dropdown-menu, .drop-down').removeClass('active')
    $('.js-open-mega').removeClass('active')
  })

  const mmV2ParentItem = $('.mm-v2-parent-item');
  const mmV2closeMenu = $('.mm-v2-close-menu .close-menu');
  const mmV2CollectionItem = $('.mm-v2-collection');
  const isTouch = $('html').hasClass('touchevents');
  const mmV2CollectionBack = $('.mm-v2-collection-back');
  const mmV2ParentItems = $('.mm-v2-parent-items');
  const enableClick = $('.enable-click');
  const body = $('body');

  enableClick.on('click',function () {
    if (isTouch && body.hasClass('menu-active')) {
      body.removeClass('menu-active');
    }
  })

  mmV2ParentItem.on('click', function (e) {
    if ($(e.target).hasClass('mm-v2-parent-item-link')) {
      if ($(e.target).hasClass('prevent-default')) {
        e.preventDefault();
      } else {
        $('.js-open-mega').removeClass('active');
      }
      $(this).addClass('mm-v2-parent-active').siblings().removeClass('mm-v2-parent-active');
      $(this).parent('.mm-v2-parent-items').addClass('mm-v2-parent-items-active');
    }
  });

  mmV2closeMenu.on('click', function (e) {
    e.preventDefault();
    $('.js-open-mega').removeClass('active');
  })

  function collectionItemsInteraction(el, event, preventDefault) {
    el.on(event, function (e) {
      if(preventDefault && !enableClick) {
        e.preventDefault();
      }
      if (isTouch) {
        $(this).not(mmV2CollectionBack).addClass('mm-v2-collection-active').parent().addClass('mm-v2-collections-active');
      } else {
        $(this).addClass('mm-v2-collection-active');
      }
      $(this).siblings().removeClass('mm-v2-collection-active');
    });
  }

  collectionItemsInteraction(mmV2CollectionItem, isTouch ? 'click' : 'mouseenter', isTouch);

  if (isTouch) {
    mmV2ParentItem.removeClass('mm-v2-parent-active');
    mmV2CollectionItem.removeClass('mm-v2-collection-active');

    $('.mm-v2-collection-item-back').on('click', (e) => {
      const mmV2CollectionsActive = $('.mm-v2-collections-active');
      e.preventDefault();
      setTimeout(function () {
        mmV2CollectionsActive.removeClass('mm-v2-collections-active');
        mmV2CollectionItem.removeClass('mm-v2-collection-active');
      })
    })
  }

  mmV2CollectionBack.on('click', function (e) {
    e.preventDefault();
    mmV2ParentItem.removeClass('mm-v2-parent-active');
    mmV2ParentItems.removeClass('mm-v2-parent-items-active');
  });

  // restore default click behaviour
  $('.mm-v2-collection-item > a').on('click', function (e) {
    e.stopPropagation();
  })

  // get product handle
  let products = $('.mm-v2-fp-data');
  $.each(products, function (i, productHtml) {
    $.getJSON(`/products/${productHtml.dataset.productHandle}.js`, function (product) {
      const featuredImage = product.featured_image;
      productHtml.innerHTML = `<img src=${featuredImage} data-product-featured-image/>
                                 <p class="text-center">${product.title}</p>
                                 <p class="text-center" data-price-wrapper>
                                    <span data-product-price>
                                      ${slate.Currency.formatMoney(product.price)}
                                    </span>
                                 </p>
                                 <a class="button default" href=${product.url}>Shop now</a>`;
    })
  });

  var mainNavSpacer = $('.main-nav-spacer'),
    mainNav = $('.main-nav')
  mainNavHeight = mainNav.outerHeight(true)
  $(document).on('scroll', function (e) {
    if (mainNavSpacer.offset().top < $(document).scrollTop()) {
      mainNav.addClass('sticky')
      $('body').addClass('menu-is-sticky')
      mainNavSpacer.css({
        height: mainNavHeight
      })

    } else {
      mainNav.removeClass('sticky')
      $('body').removeClass('menu-is-sticky')
      mainNavSpacer.css({
        height: ''
      })
    }
  })

  //Cart js stuff

  // add to cart dropdown

  let addToCartDropdownMenu = $('.add-to-cart-dropdown-menu')

  $('body').on('click', function (e) {
    let $target = $(e.target)
    if (!$target.hasClass('add-to-cart-toggle')) {
      $('.product').removeClass('js-active')
    }
  })

  // append dropdown to body when in overflow hidden containers

  // hold onto the drop down menu
  var dropdownMenu

  // and when you show it, move it to the body
  $(window).on('show.bs.dropdown', function (e) {

    // grab the menu
    dropdownMenu = $(e.target).find('.dropdown-menu')
    dropdownMenu.prev().addClass('js-active')
    // detach it and append it to the body
    $('body').append(dropdownMenu.detach())

    // grab the new offset position
    var eOffset = $(e.target).offset()

    // make sure to place it where it would normally go (this could be improved)
    dropdownMenu.css({
      'display': 'block',
      'top': eOffset.top + $(e.target).outerHeight(),
      'left': eOffset.left
    })
  })

  // and when you hide it, reattach the drop down, and hide it normally
  $(window).on('hide.bs.dropdown', function (e) {
    $(e.target).append(dropdownMenu.detach())
    dropdownMenu.hide()
    dropdownMenu.prev().removeClass('js-active')
  })

  addToCartDropdownMenu.on('click', function () {
    $(this).parent('.add-to-cart-dropdown').removeClass('js-active')
  })

  let itemCount = CartJS.cart.item_count

  $('body').on('click', function (e) {
    let $target = $(e.target)
    if ($target.hasClass('js-add')) {
      $target.addClass('active')
    }
    if ($target.parent().hasClass('add-to-cart-dropdown-menu, .default.dropdown')) {
      $target.parent().siblings('.add-to-cart-toggle, .dropdown-toggle').addClass('active')
    }
  })

  $(document).on('cart.requestStarted', function (event, cart) {
    $('.js-add.product-add-to-bag, .js-add.active, .add-to-cart-toggle.active, .dropdown-toggle.active').addClass('loading').removeClass('active')
    $('.error-text').html('')
  })

  $(document).on('cart.requestComplete', function (event, cart) {
    $('#counter').html(cart.item_count)
    $('.js-add, .add-to-cart-toggle,.dropdown-toggle').addClass('done')
    $('.cart-draw-container, body').addClass('open')
    itemCount = cart.item_count;
    cart.free_product_id = freeProductId;

    $.each(cart.items, function (key, item) {
      if (item.id === freeProductId || item.product_type === 'MOTIVATOR_HIDDEN_PRODUCT') {
        item.is_free = true;
        if (item.is_free && item.quantity !== 1) {
          CartJS.updateItemById(freeProductId, 1);
        }
      } else {
        item.is_free = false;
      }
    });

    setTimeout(function () {
      $('.js-add, .add-to-cart-toggle,.dropdown-toggle').removeClass('loading done')
    }, 2000)
  })

  $('.js-close-draw, .cart-draw-shade').on('click', function (e) {
    e.preventDefault()
    $('.cart-draw-container, body').removeClass('open')
  })

  // replace selects
  $('select').niceSelect()
  $('select.stamped-sort-select').niceSelect('destroy')

  $('.product-slider, .collection-slider, .row.recipe-products').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 651,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  })

  $('.product-image-slider').slick({
    dots: true
  })

  const freeShippingThreshold = parseInt($('.free-shipping-threshold').text());

  CartJS.cart.free_shipping = freeShippingThreshold;

  // Add topbar padding to mega menu
  let $topbarHeight = $('.topbar').innerHeight(),
    $navbarWrapper = $('.nav-wrapper'),
    $widthBreakpoint = 992,
    width = $(window).width()

  if (width < $widthBreakpoint) {
    $navbarWrapper.css({paddingTop: 75 + $topbarHeight + 'px'})
  }

  $(window).on('resize', function () {
    let win = $(this)
    if (win.width() < $widthBreakpoint) {
      $navbarWrapper.css({paddingTop: 75 + $topbarHeight + 'px'})
    } else if (win.width() > $widthBreakpoint) {
      $navbarWrapper.css({paddingTop: 0})
    }
  })

  // Update cart AJAX
  const freeProductId = parseInt($('.free-product-id').text());
  // var $cartTotal = freeShippingThreshold - CartJS.cart.total_price,
  // $continueShopping = '<a style="margin-left:5px;" href="/collections/all">Continue shopping.</a>',
  // $freeShippingMsg = $('#free-shipping-message')

  // if (CartJS.cart.total_price > freeShippingThreshold) {
  //   $freeShippingMsg.html('Yay! You have qualified for free shipping (Aus only excl WA)')
  // } else {
  //   $freeShippingMsg.html('You\'re ' + slate.Currency.formatMoney($cartTotal) + ' away from free shipping. (Aus only excl WA)' + $continueShopping)
  // }
  $('.line-item-qty').change(function () {
    var $this = $(this),
      $item = $('.line-item-container'),
      $thisItem = $this.closest($item),
      $variantId = $this.attr('variant-id'),
      $qty = $this.val(),
      $subtotal = $('.cart-total-price'),
      $lineItemTotal = $thisItem.find('.line-item-total'),
      $loading = true;

    if ($loading) {
      $lineItemTotal.html('Updating...')
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        quantity: $qty,
        id: $variantId
      },
      success: function (cart) {
        $loading = false;
        $.each(cart.items, function (key, item) {
          if (parseInt($variantId) === item.variant_id) {
            $lineItemTotal.html(slate.Currency.formatMoney(item.line_price, theme.moneyFormat))
          }
        })
        $subtotal.html(slate.Currency.formatMoney(cart.total_price, theme.moneyFormat))
        if (cart.total_price > freeShippingThreshold) {
          $freeShippingMsg.html('Yay! You have qualified free shipping')
        } else {
          $freeShippingMsg.html('You\'re ' + slate.Currency.formatMoney((freeShippingThreshold - cart.total_price)) + ' away from free shipping. ' + $continueShopping)
        }
      },
      error: function (response) {
        console.error('Error in updating cart:',response)
      }
    }).done( function (cart) {
      slate.cart.updateGiftInCart(cart.total_price, cart.items, $qty);
    });
  })

  var qty = 1

  function updateAttr (element, value, attribute, button) {
    $(element).change(function () {
      value = $(element).val() || 1
      $(button).attr(attribute, value)
    })
  }

  updateAttr('#Quantity', qty, 'data-cart-quantity', '.product-add-to-bag')

  var count = 0

  $('.subtract').on('click', function (e) {
    e.preventDefault()
    if (count - 1 >= 0) {
      count = $(this).parent().find('#quantity').val()
      count = count - 1
      $(this).parent().find('#quantity').val(count)
    } else {
      alert('Nothing to take away!')
    }
  })
  $('.add').on('click', function (e) {
    e.preventDefault()
    count = parseInt($(this).parent().find('#quantity').val())
    count = count + 1
    $(this).parent().find('#quantity').val(count)
  })


  // Stats counter

  let statsCount = $('.stat-count'),
    statsIcon = $('.stats-icon')

  function isScrolledIntoView (elem) {
    let docViewTop = $(window).scrollTop()
    let docViewBottom = docViewTop + $(window).height()

    let elemTop = $(elem).offset().top
    let elemBottom = elemTop + $(elem).height()

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
  }

  if (statsCount && statsCount[0] && isScrolledIntoView(statsCount)) {
    animateCounter(statsCount)
  } else if (statsCount && statsCount[0]) {
    $(document).on('scroll', function () {
      if (isScrolledIntoView(statsCount[0])) {
        animateCounter(statsCount)
      }
    })
  }

  function animateCounter (counters) {
    counters.each(function () {
      var $this = $(this),
        countTo = $this.attr('data-count')

      $({countNum: $this.text()}).animate({
          countNum: countTo
        },

        {
          duration: 2000,
          easing: 'linear',
          step: function () {
            $this.text(Math.floor(this.countNum))
          },
          complete: function () {
            $this.text(this.countNum)
          }

        })
    })
  }

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash))

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash))
  })

  // Target tables to make them scrollable
  var tableSelectors = '.rte table'

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  })

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]'

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  })

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies')
  }

  theme.productCollectionsCard.productCard();
  slate.cart.updateFreeGiftOnPageLoad(CartJS.cart.items, CartJS.cart.total_price);

  // binders for cart drawer
  rivets.binders.productId = (el, value) => el.data.productId = value;
  rivets.binders.productPrice = (el, value) => el.data.productPrice = value;
  rivets.formatters.length = (value) => value ? (value.length || 0) : 0;

  let sliderVids = $('#slider-video').length;

  if (sliderVids !== 0) {
    if (sliderVids > 1) {
      for (let i = 0; i < sliderVids; i++) {
        $('#slider-video')[i].play();
      }
    } else {
      $('#slider-video')[0].play();
    }
  }

  const clickToCopy = $('.click-to-copy');
  clickToCopy.on('click', function (e) {
    e.preventDefault();
    const clipboard = navigator.clipboard;
    const copiedText = e.currentTarget.innerText;
    const $this = $(this);
    clipboard.writeText(copiedText);
    $this.text('COPIED!');
    setTimeout(function () {
      $this.text(copiedText);
    }, 3000);
  });

})

// Collagen Build Guide Download

const button = document.querySelector('.cbg-download')
const input = document.querySelector('.cbg-input')
const error = document.querySelector('.cbg-error')
if (input) {
  input.addEventListener('keyup', (e) => {
    let value = e.target.value

    if (value === '2403' || value === '2410') {
      button.setAttribute('href', 'https://cdn.shopify.com/s/files/1/0067/5531/9923/files/Nutra-Revie-Jane-Workout-Nutrition-Guide.pdf?11356')
      button.classList.remove('disabled')
    } else {
      button.setAttribute('href', '')
      button.classList.add('disabled')
      if (value.length === 4) {
        setTimeout(() => {
          error.classList.remove('visually-hidden')
        }, 100)
      } else {
        error.classList.add('visually-hidden')
      }

    }
    e.preventDefault()
  })
}

const fiftyImage = document.querySelector('.fifty-fifty-img img')
const fiftyContent = document.querySelector('.fifty-fifty-content')

window.addEventListener('load', () => {
  if (fiftyContent) {
    fiftyContent.style.maxHeight = fiftyImage.scrollHeight + 'px'
  }
})

if (window.innerWidth < 990 && fiftyContent) {
  fiftyContent.style.height = 'auto'
  fiftyContent.style.maxHeight = ''
}

if (fiftyContent) {
  window.addEventListener('resize', () => {
    if (window.innerWidth > 990 && fiftyContent) {
      fiftyContent.style.maxHeight = fiftyImage.scrollHeight + 'px'
    } else {
      fiftyContent.style.height = 'auto'
      fiftyContent.style.maxHeight = ''
    }
  })
}
